import { useEffect, useState } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCompose, setShowCompose] = useState(false);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    let mounted = true;
    axios
      .get("/auth/users")
      .then(({ data }) => {
        if (mounted) setUsers(data || []);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => mounted && setLoading(false));
    return () => (mounted = false);
  }, []);

  const copyEmail = (email) => {
    if (!navigator.clipboard) return alert("Clipboard not supported");
    navigator.clipboard.writeText(email).then(() => {
      alert("Email copied");
    });
  };

  const handleSendAll = async (e) => {
    e.preventDefault();
    if (!subject.trim() || !message.trim()) {
      return alert("Please provide subject and message");
    }
    if (users.length === 0) return alert("No users to send to");
    setSending(true);
    try {
      await axios.post(
        "/auth/send-email",
        { subject, message },
        { withCredentials: true }
      );
      alert("Emails queued/sent successfully");
      setShowCompose(false);
      setSubject("");
      setMessage("");
    } catch (err) {
      console.error(err);
      alert("Failed to send emails");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="users_page">
      <NavLink to="/home" className="main_logo">
        <img src="/logo.webp" alt="logo" className="logo_image" />
        {/* <h2>PayoutProphet</h2> */}
        <div className="logo_text">
          <span>Asakaa Play</span>
          {/* <span>Play</span> */}
        </div>
      </NavLink>
      <header className="users_header">
        <h1>Users</h1>
        <div className="users_actions">
          <span className="users_count">
            {loading ? "Loading..." : `${users.length} users`}
          </span>
          <button
            className="send_all_btn"
            onClick={() => setShowCompose(true)}
            disabled={users.length === 0 || loading}
            title="Send email to all users"
          >
            Send Email to All
          </button>
        </div>
      </header>

      <main className="users_list">
        {loading ? (
          <p className="muted">Loading users…</p>
        ) : users.length === 0 ? (
          <p className="muted">No users found</p>
        ) : (
          users.map((u) => (
            <div key={u._id || u.id || u.email} className="user_item">
              <div className="user_info">
                <div className="user_name">{u.name || "—"}</div>
                <div className="user_email">{u.email}</div>
              </div>
              <div className="user_actions">
                <button
                  className="btn small"
                  onClick={() => copyEmail(u.email)}
                >
                  Copy
                </button>
              </div>
            </div>
          ))
        )}
      </main>

      {showCompose && (
        <div className="compose_overlay" role="dialog" aria-modal="true">
          <form className="compose_box" onSubmit={handleSendAll}>
            <h3>Send Email to All Users</h3>
            <label>
              Subject
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Subject"
              />
            </label>
            <label>
              Message
              <textarea
                rows={8}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Write your message here..."
              />
            </label>

            <div className="compose_actions">
              <button
                type="button"
                className="btn btn_border"
                onClick={() => setShowCompose(false)}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn_submit"
                disabled={sending}
              >
                {sending ? "Sending…" : `Send to ${users.length} users`}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default Users;
